import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../../Shared/DataTable";
import { MdDelete, MdSearch, MdModeEdit } from "react-icons/md"; 
import { dateTimeutils, dateFormats } from "../../../_utils";

export class DealsTable extends Component {
  render() {
    const columns = [
      {
        Header: "",
        accessor: "imageUrl",
        Cell: row => (
          <img
            className="img-thumbnail rounded"
            alt={row.original.name}
            style={{ height: "50px" }}
            src={row.original.imageUrl}
          />
        )
      },
      {
        Header: "Name",
        accessor: "name"
      },
      {
        Header: "Merchant",
        accessor: "merchantName"
      },
      {
        Header: "Category",
        accessor: "categoryName"
      },
      {
        Header: "End Date",
        id: "endDate",
        accessor: "endAt",
        Cell: row => (
          <span>
            {dateTimeutils.formatDateTime(
              row.original.endAt,
              dateFormats.localFormatLong
            )}
          </span>
        )
      }
    ];

    const {
      match,
      fetching,
      data,
      error,
      filterData,
      selectRow,
      pages,
      page,
      pageSize,
      deleteRow,
      showModal,
      setPageNumber,
      setPageSize
    } = this.props;

    const actions = [
      {
        name: "edit",
        btnText: "",
        btnAction: selectRow,
        btnClass: "btn-primary btn-sm",
        btnIcon: MdModeEdit,
        tooltip: "Edit"
      },
      {
        name: "view",
        btnText: "",
        btnAction: selectRow,
        btnClass: "btn-success btn-sm",
        btnIcon: MdSearch,
        tooltip: "View"
      },
      {
        name: "cancel",
        btnText: "",
        btnAction: showModal,
        btnClass: "btn-danger btn-sm",
        btnIcon: MdDelete,
        hiddenParam: "hasPassed",
        tooltip: "Delete"
      }
    ];

    return (
      <div>
        <Card className="pp4">
          <CardHeader>Deals</CardHeader>
          <CardBody>
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}
            <DataTable
              columns={columns}
              loading={fetching}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              urlParams={match}
              data={data ? data.data : []}
              count={data ? data.count : 0}
              defaultPageSize={10}
              deleteRow={deleteRow}
              selectRow={selectRow}
              showModal={showModal}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="search-key"
              searchPlaceholder="Search by name/merchant"
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default DealsTable;
